var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"deltia-card ma-2 pt-6 pl-5 pr-5",attrs:{"no-gutters":"","align":"center","justify":"center"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }